// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- ГЛАВНЫЙ КОНТЕЙНЕР (СЕЙФ) --- */
.safecracker-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 90%;
  max-width: 340px;

  /* Текстура металла */
  background: linear-gradient(135deg, #3a3a3a 0%, #222 100%);
  border: 4px solid #1a1a1a;
  box-shadow:
    inset 1px 1px 0px rgba(255,255,255,0.1),
    0 20px 50px rgba(0,0,0,0.8);

  border-radius: 20px;
  padding: 15px;
  padding-bottom: 25px; /* Чуть больше снизу для баланса */

  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 6000; /* Выше всего */
  pointer-events: auto; /* ВАЖНО: перехват кликов */
  font-family: 'Courier New', Courier, monospace;
}

/* Декоративные болты по углам */
.safecracker-container::before,
.safecracker-container::after {
  content: '';
  position: absolute;
  top: 10px;
  width: 8px;
  height: 8px;
  background: #111;
  border-radius: 50%;
  box-shadow: 0 1px 0 rgba(255,255,255,0.1);
}
.safecracker-container::before { left: 10px; }
.safecracker-container::after { right: 10px; }

/* --- HEADER REDESIGN --- */
.safecracker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 8px 12px;
  background: #151515;
  border-radius: 6px;
  border: 1px solid #333;
  box-shadow: inset 0 2px 5px rgba(0,0,0,0.8);
  gap: 15px;
}

.header-left {
  display: flex;
  gap: 12px;
  align-items: center;
}

.header-right {
  display: flex;
  align-items: center;
  border-left: 1px solid #333;
  padding-left: 10px;
}

.safecracker-stat {
  font-size: 10px;
  font-weight: 700;
  color: #777;
  letter-spacing: 0.5px;
  display: flex;
  align-items: baseline;
  gap: 4px;
  white-space: nowrap;
}

.sc-highlight {
  color: #e0c097;
  font-size: 13px;
}

/* --- ИСТОРИЯ (УВЕЛИЧЕННАЯ) --- */
.safecracker-history {
  width: 100%;
  /* Увеличиваем высоту, так как сэкономили место на таймере */
  height: 180px;
  overflow-y: auto;

  /* Эффект старой бумаги */
  background-color: #fdf6e3;
  color: #333;
  border: 1px solid #c0b090;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 10px;

  display: flex;
  flex-direction: column-reverse;
  box-sizing: border-box;
  font-size: 16px;
  font-weight: bold;
  box-shadow: inset 0 0 15px rgba(0,0,0,0.15);
}

.history-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px dashed #d1ccb8;
}

.history-guess {
  letter-spacing: 5px;
  font-size: 18px;
  color: #222;
}

.history-result {
  display: flex;
  gap: 8px;
  background: rgba(0,0,0,0.05);
  padding: 2px 6px;
  border-radius: 10px;
}

/* Огоньки (Лампочки) */
.bulb {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 4px;
  border: 1px solid rgba(0,0,0,0.2);
}

.bulb-green { background-color: #4cd137; box-shadow: 0 0 5px #4cd137; }
.bulb-yellow { background-color: #fbc531; box-shadow: 0 0 5px #fbc531; }

/* --- CONTROLS CONTAINER --- */
.safecracker-controls {
  display: flex;
  align-items: flex-start; /* Align both columns to the top */
  justify-content: space-between;
  gap: 15px; /* Gap between Left and Right columns */
  width: 100%;
  margin-top: 10px;
}

/* --- LEFT COLUMN --- */
.safecracker-input-column {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  /* CRITICAL: Must match the grid-gap of the keypad exactly */
  gap: 8px;
}

/* 1) Input Field (Matches Row 1 of Keypad) */
.safecracker-input {
  width: 100%;
  background: #000;
  border: 2px solid #333;
  border-radius: 6px;
  color: #e0c097;

  /* Reduced font size */
  font-size: 26px;

  text-align: center;
  letter-spacing: 8px;
  font-family: 'Courier New', monospace;
  outline: none;

  /* Fix vertical alignment */
  height: 47px;
  line-height: 46px; /* Slightly less than height accounting for border (2px+2px) usually centers perfectly */
  padding: 0;        /* Remove padding to rely on line-height */

  /* Make cursor visible again (standard blinking) */
  caret-color: rgba(224, 192, 151, 0.0);
  cursor: text;

  box-shadow: inset 0 2px 5px rgba(0,0,0,0.8);
  transition: border-color 0.2s;
}

.safecracker-input::placeholder {
  /* Ensure placeholder (dots) aligns same as text */
  line-height: 46px;
  color: #555;
}

.safecracker-input:focus {
  border-color: #e0c097;
}

/* 2) Gold Button (Matches Row 2 of Keypad) */
.safecracker-big-btn {
  width: 100%;
  height: 46px;
  box-sizing: border-box;

  background: linear-gradient(to bottom, #d4af37, #aa8c2c);
  color: #3e2723;

  /* Text Styling */
  font-size: 18px; /* Adjusted for text */
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-family: 'Courier New', monospace;

  border: 1px solid #7c641d;
  border-radius: 6px;
  cursor: pointer;
  box-shadow: 0 4px 0 #7c641d;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.1s, box-shadow 0.1s;
}

.safecracker-big-btn:active {
  transform: translateY(4px);
  box-shadow: 0 0 0 #7c641d;
}

/* --- ОВЕРЛЕЙ ПОБЕДЫ --- */
.safecracker-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;
  border-radius: 16px;
  animation: fadeIn 0.3s;
}

.win-title {
  font-size: 24px;
  color: #4cd137;
  margin-bottom: 10px;
  text-transform: uppercase;
  font-weight: bold;
}

.win-score {
  font-size: 16px;
  color: #fff;
}


/* Адаптация для мобильных, если очень узко */
@media (max-width: 340px) {
  .safecracker-input { font-size: 28px; letter-spacing: 4px; }
  .keypad-btn { width: 38px; height: 38px; font-size: 16px; }
}

/* --- НИЖНИЕ БОЛТЫ --- */
.safecracker-rivets-bottom {
  position: absolute;
  bottom: 0; left: 0; right: 0;
  height: 0;
  pointer-events: none;
}
.safecracker-rivets-bottom::before,
.safecracker-rivets-bottom::after {
  content: '';
  position: absolute;
  bottom: 10px;
  width: 8px;
  height: 8px;
  background: #111;
  border-radius: 50%;
  box-shadow: 0 1px 0 rgba(255,255,255,0.1);
}
.safecracker-rivets-bottom::before { left: 10px; }
.safecracker-rivets-bottom::after { right: 10px; }

/* --- RIGHT COLUMN (Keypad) --- */
.safecracker-keypad {
  flex-shrink: 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  /* CRITICAL: Gap matches Left Column gap */
  gap: 8px;
}

.keypad-btn {
  width: 50px; /* Fixed square size */
  height: 50px; /* CRITICAL: Height matches Input and Big Button */

  background: linear-gradient(to bottom, #2e2e2e, #1a1a1a);
  color: #ccc;
  font-family: 'Courier New', monospace;
  font-size: 20px;
  font-weight: bold;
  border: 1px solid #444;
  border-radius: 6px;
  cursor: pointer;
  box-shadow: 0 3px 0 #000;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.05s;
}

.keypad-btn:active {
  transform: translateY(2px);
  box-shadow: 0 1px 0 #000;
}

/* Specific colors for actions */
.keypad-back { color: #d63031; border-color: #502020; }
.keypad-submit { color: #4cd137; border-color: #205020; }

/* --- ЭКРАН РЕЗУЛЬТАТОВ --- */

/* Оверлей результатов */
.final-report {
  position: absolute;
  top: 20px;
  left: 20px;
  right: 20px;
  bottom: 20px;
  background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);
  border: 3px solid #444;
  border-radius: 15px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #e0c097;
  font-family: 'Courier New', monospace;
  box-shadow: inset 0 2px 10px rgba(0,0,0,0.8);
  z-index: 15;
}

.report-header {
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
  border-bottom: 2px solid #555;
  padding-bottom: 10px;
}

.report-title {
  font-size: 18px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #e0c097;
}

.final-stats {
  text-align: center;
  margin-bottom: 25px;
  width: 100%;
}

.final-score {
  font-size: 36px;
  font-weight: bold;
  color: #4cd137;
  margin-bottom: 15px;
  font-family: 'Courier New', monospace;
  border: 2px solid #4cd137;
  display: inline-block;
  padding: 8px 16px;
  border-radius: 8px;
  background: rgba(76, 209, 55, 0.1);
}

.stat-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  padding: 5px 0;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}

.stat-label {
  font-size: 14px;
  color: #aaa;
  font-weight: bold;
}

.stat-value {
  font-size: 16px;
  color: #e0c097;
  font-weight: bold;
}

.rank-title {
  color: #d4af37;
  text-transform: uppercase;
  font-size: 14px;
}

/* ЛИДЕРБОРД */
.leaderboard-section {
  width: 100%;
  margin-bottom: 20px;
}

.leaderboard-title {
  font-size: 14px;
  font-weight: 900;
  text-align: center;
  color: #d4af37;
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.leaderboard-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.leaderboard-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: rgba(0,0,0,0.3);
  border-radius: 6px;
  border-left: 3px solid #666;
}

.leaderboard-item.gold {
  border-left-color: #d4af37;
  background: rgba(212, 175, 55, 0.1);
}

.leaderboard-item.silver {
  border-left-color: #c0c0c0;
  background: rgba(192, 192, 192, 0.1);
}

.leaderboard-item.bronze {
  border-left-color: #cd7f32;
  background: rgba(205, 127, 50, 0.1);
}

.rank-number {
  font-size: 14px;
  font-weight: bold;
  color: #aaa;
  min-width: 30px;
}

.player-name {
  flex: 1 1;
  text-align: center;
  font-size: 14px;
  color: #e0c097;
}

.player-score {
  font-size: 16px;
  font-weight: bold;
  color: #4cd137;
  min-width: 40px;
  text-align: right;
}

/* КНОПКА ЗАКРЫТИЯ */
.safecracker-close-btn {
  background: linear-gradient(to bottom, #d4af37, #aa8c2c);
  color: #3e2723;
  border: 2px solid #7c641d;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-family: 'Courier New', monospace;
  cursor: pointer;
  box-shadow: 0 4px 0 #7c641d;
  transition: all 0.1s;
  margin-top: auto;
}

.safecracker-close-btn:active {
  transform: translateY(4px);
  box-shadow: 0 0 0 #7c641d;
}`, "",{"version":3,"sources":["webpack://./src/components/arcade/games/safecracker/SafeCracker.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;;EAEhC,UAAU;EACV,gBAAgB;;EAEhB,qBAAqB;EACrB,0DAA0D;EAC1D,yBAAyB;EACzB;;+BAE6B;;EAE7B,mBAAmB;EACnB,aAAa;EACb,oBAAoB,EAAE,kCAAkC;;EAExD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa,EAAE,eAAe;EAC9B,oBAAoB,EAAE,2BAA2B;EACjD,8CAA8C;AAChD;;AAEA,gCAAgC;AAChC;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;AACA,iCAAiC,UAAU,EAAE;AAC7C,gCAAgC,WAAW,EAAE;;AAE7C,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,2CAA2C;EAC3C,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,4DAA4D;EAC5D,aAAa;EACb,gBAAgB;;EAEhB,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;;EAEnB,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA,cAAc,yBAAyB,EAAE,2BAA2B,EAAE;AACtE,eAAe,yBAAyB,EAAE,2BAA2B,EAAE;;AAEvE,+BAA+B;AAC/B;EACE,aAAa;EACb,uBAAuB,EAAE,kCAAkC;EAC3D,8BAA8B;EAC9B,SAAS,EAAE,uCAAuC;EAClD,WAAW;EACX,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,4DAA4D;EAC5D,QAAQ;AACV;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;;EAEd,sBAAsB;EACtB,eAAe;;EAEf,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;;EAEb,2BAA2B;EAC3B,YAAY;EACZ,iBAAiB,EAAE,wFAAwF;EAC3G,UAAU,SAAS,0CAA0C;;EAE7D,kDAAkD;EAClD,qCAAqC;EACrC,YAAY;;EAEZ,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,kDAAkD;EAClD,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;;EAEtB,wDAAwD;EACxD,cAAc;;EAEd,iBAAiB;EACjB,eAAe,EAAE,sBAAsB;EACvC,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;;EAErC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;;AAGA,6CAA6C;AAC7C;EACE,qBAAqB,eAAe,EAAE,mBAAmB,EAAE;EAC3D,cAAc,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE;AAC5D;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,SAAS,EAAE,OAAO,EAAE,QAAQ;EAC5B,SAAS;EACT,oBAAoB;AACtB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;AACA,qCAAqC,UAAU,EAAE;AACjD,oCAAoC,WAAW,EAAE;;AAEjD,kCAAkC;AAClC;EACE,cAAc;EACd,aAAa;EACb,qCAAqC;EACrC,0CAA0C;EAC1C,QAAQ;AACV;;AAEA;EACE,WAAW,EAAE,sBAAsB;EACnC,YAAY,EAAE,kDAAkD;;EAEhE,wDAAwD;EACxD,WAAW;EACX,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA,gCAAgC;AAChC,eAAe,cAAc,EAAE,qBAAqB,EAAE;AACtD,iBAAiB,cAAc,EAAE,qBAAqB,EAAE;;AAExD,8BAA8B;;AAE9B,wBAAwB;AACxB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,qCAAqC;EACrC,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,wDAAwD;EACxD,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;EACf,2BAA2B;EAC3B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B","sourcesContent":["/* --- ГЛАВНЫЙ КОНТЕЙНЕР (СЕЙФ) --- */\n.safecracker-container {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  width: 90%;\n  max-width: 340px;\n\n  /* Текстура металла */\n  background: linear-gradient(135deg, #3a3a3a 0%, #222 100%);\n  border: 4px solid #1a1a1a;\n  box-shadow:\n    inset 1px 1px 0px rgba(255,255,255,0.1),\n    0 20px 50px rgba(0,0,0,0.8);\n\n  border-radius: 20px;\n  padding: 15px;\n  padding-bottom: 25px; /* Чуть больше снизу для баланса */\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  z-index: 6000; /* Выше всего */\n  pointer-events: auto; /* ВАЖНО: перехват кликов */\n  font-family: 'Courier New', Courier, monospace;\n}\n\n/* Декоративные болты по углам */\n.safecracker-container::before,\n.safecracker-container::after {\n  content: '';\n  position: absolute;\n  top: 10px;\n  width: 8px;\n  height: 8px;\n  background: #111;\n  border-radius: 50%;\n  box-shadow: 0 1px 0 rgba(255,255,255,0.1);\n}\n.safecracker-container::before { left: 10px; }\n.safecracker-container::after { right: 10px; }\n\n/* --- HEADER REDESIGN --- */\n.safecracker-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n  padding: 8px 12px;\n  background: #151515;\n  border-radius: 6px;\n  border: 1px solid #333;\n  box-shadow: inset 0 2px 5px rgba(0,0,0,0.8);\n  gap: 15px;\n}\n\n.header-left {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  border-left: 1px solid #333;\n  padding-left: 10px;\n}\n\n.safecracker-stat {\n  font-size: 10px;\n  font-weight: 700;\n  color: #777;\n  letter-spacing: 0.5px;\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n  white-space: nowrap;\n}\n\n.sc-highlight {\n  color: #e0c097;\n  font-size: 13px;\n}\n\n/* --- ИСТОРИЯ (УВЕЛИЧЕННАЯ) --- */\n.safecracker-history {\n  width: 100%;\n  /* Увеличиваем высоту, так как сэкономили место на таймере */\n  height: 180px;\n  overflow-y: auto;\n\n  /* Эффект старой бумаги */\n  background-color: #fdf6e3;\n  color: #333;\n  border: 1px solid #c0b090;\n  border-radius: 4px;\n  padding: 10px;\n  margin-bottom: 10px;\n\n  display: flex;\n  flex-direction: column-reverse;\n  box-sizing: border-box;\n  font-size: 16px;\n  font-weight: bold;\n  box-shadow: inset 0 0 15px rgba(0,0,0,0.15);\n}\n\n.history-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 0;\n  border-bottom: 1px dashed #d1ccb8;\n}\n\n.history-guess {\n  letter-spacing: 5px;\n  font-size: 18px;\n  color: #222;\n}\n\n.history-result {\n  display: flex;\n  gap: 8px;\n  background: rgba(0,0,0,0.05);\n  padding: 2px 6px;\n  border-radius: 10px;\n}\n\n/* Огоньки (Лампочки) */\n.bulb {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  margin-right: 4px;\n  border: 1px solid rgba(0,0,0,0.2);\n}\n\n.bulb-green { background-color: #4cd137; box-shadow: 0 0 5px #4cd137; }\n.bulb-yellow { background-color: #fbc531; box-shadow: 0 0 5px #fbc531; }\n\n/* --- CONTROLS CONTAINER --- */\n.safecracker-controls {\n  display: flex;\n  align-items: flex-start; /* Align both columns to the top */\n  justify-content: space-between;\n  gap: 15px; /* Gap between Left and Right columns */\n  width: 100%;\n  margin-top: 10px;\n}\n\n/* --- LEFT COLUMN --- */\n.safecracker-input-column {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  /* CRITICAL: Must match the grid-gap of the keypad exactly */\n  gap: 8px;\n}\n\n/* 1) Input Field (Matches Row 1 of Keypad) */\n.safecracker-input {\n  width: 100%;\n  background: #000;\n  border: 2px solid #333;\n  border-radius: 6px;\n  color: #e0c097;\n\n  /* Reduced font size */\n  font-size: 26px;\n\n  text-align: center;\n  letter-spacing: 8px;\n  font-family: 'Courier New', monospace;\n  outline: none;\n\n  /* Fix vertical alignment */\n  height: 47px;\n  line-height: 46px; /* Slightly less than height accounting for border (2px+2px) usually centers perfectly */\n  padding: 0;        /* Remove padding to rely on line-height */\n\n  /* Make cursor visible again (standard blinking) */\n  caret-color: rgba(224, 192, 151, 0.0);\n  cursor: text;\n\n  box-shadow: inset 0 2px 5px rgba(0,0,0,0.8);\n  transition: border-color 0.2s;\n}\n\n.safecracker-input::placeholder {\n  /* Ensure placeholder (dots) aligns same as text */\n  line-height: 46px;\n  color: #555;\n}\n\n.safecracker-input:focus {\n  border-color: #e0c097;\n}\n\n/* 2) Gold Button (Matches Row 2 of Keypad) */\n.safecracker-big-btn {\n  width: 100%;\n  height: 46px;\n  box-sizing: border-box;\n\n  background: linear-gradient(to bottom, #d4af37, #aa8c2c);\n  color: #3e2723;\n\n  /* Text Styling */\n  font-size: 18px; /* Adjusted for text */\n  font-weight: 900;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  font-family: 'Courier New', monospace;\n\n  border: 1px solid #7c641d;\n  border-radius: 6px;\n  cursor: pointer;\n  box-shadow: 0 4px 0 #7c641d;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.1s, box-shadow 0.1s;\n}\n\n.safecracker-big-btn:active {\n  transform: translateY(4px);\n  box-shadow: 0 0 0 #7c641d;\n}\n\n/* --- ОВЕРЛЕЙ ПОБЕДЫ --- */\n.safecracker-overlay {\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: rgba(0,0,0,0.9);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  z-index: 10;\n  border-radius: 16px;\n  animation: fadeIn 0.3s;\n}\n\n.win-title {\n  font-size: 24px;\n  color: #4cd137;\n  margin-bottom: 10px;\n  text-transform: uppercase;\n  font-weight: bold;\n}\n\n.win-score {\n  font-size: 16px;\n  color: #fff;\n}\n\n\n/* Адаптация для мобильных, если очень узко */\n@media (max-width: 340px) {\n  .safecracker-input { font-size: 28px; letter-spacing: 4px; }\n  .keypad-btn { width: 38px; height: 38px; font-size: 16px; }\n}\n\n/* --- НИЖНИЕ БОЛТЫ --- */\n.safecracker-rivets-bottom {\n  position: absolute;\n  bottom: 0; left: 0; right: 0;\n  height: 0;\n  pointer-events: none;\n}\n.safecracker-rivets-bottom::before,\n.safecracker-rivets-bottom::after {\n  content: '';\n  position: absolute;\n  bottom: 10px;\n  width: 8px;\n  height: 8px;\n  background: #111;\n  border-radius: 50%;\n  box-shadow: 0 1px 0 rgba(255,255,255,0.1);\n}\n.safecracker-rivets-bottom::before { left: 10px; }\n.safecracker-rivets-bottom::after { right: 10px; }\n\n/* --- RIGHT COLUMN (Keypad) --- */\n.safecracker-keypad {\n  flex-shrink: 0;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  /* CRITICAL: Gap matches Left Column gap */\n  gap: 8px;\n}\n\n.keypad-btn {\n  width: 50px; /* Fixed square size */\n  height: 50px; /* CRITICAL: Height matches Input and Big Button */\n\n  background: linear-gradient(to bottom, #2e2e2e, #1a1a1a);\n  color: #ccc;\n  font-family: 'Courier New', monospace;\n  font-size: 20px;\n  font-weight: bold;\n  border: 1px solid #444;\n  border-radius: 6px;\n  cursor: pointer;\n  box-shadow: 0 3px 0 #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.05s;\n}\n\n.keypad-btn:active {\n  transform: translateY(2px);\n  box-shadow: 0 1px 0 #000;\n}\n\n/* Specific colors for actions */\n.keypad-back { color: #d63031; border-color: #502020; }\n.keypad-submit { color: #4cd137; border-color: #205020; }\n\n/* --- ЭКРАН РЕЗУЛЬТАТОВ --- */\n\n/* Оверлей результатов */\n.final-report {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  right: 20px;\n  bottom: 20px;\n  background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);\n  border: 3px solid #444;\n  border-radius: 15px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: #e0c097;\n  font-family: 'Courier New', monospace;\n  box-shadow: inset 0 2px 10px rgba(0,0,0,0.8);\n  z-index: 15;\n}\n\n.report-header {\n  width: 100%;\n  text-align: center;\n  margin-bottom: 20px;\n  border-bottom: 2px solid #555;\n  padding-bottom: 10px;\n}\n\n.report-title {\n  font-size: 18px;\n  font-weight: 900;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: #e0c097;\n}\n\n.final-stats {\n  text-align: center;\n  margin-bottom: 25px;\n  width: 100%;\n}\n\n.final-score {\n  font-size: 36px;\n  font-weight: bold;\n  color: #4cd137;\n  margin-bottom: 15px;\n  font-family: 'Courier New', monospace;\n  border: 2px solid #4cd137;\n  display: inline-block;\n  padding: 8px 16px;\n  border-radius: 8px;\n  background: rgba(76, 209, 55, 0.1);\n}\n\n.stat-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  padding: 5px 0;\n  border-bottom: 1px solid rgba(255,255,255,0.1);\n}\n\n.stat-label {\n  font-size: 14px;\n  color: #aaa;\n  font-weight: bold;\n}\n\n.stat-value {\n  font-size: 16px;\n  color: #e0c097;\n  font-weight: bold;\n}\n\n.rank-title {\n  color: #d4af37;\n  text-transform: uppercase;\n  font-size: 14px;\n}\n\n/* ЛИДЕРБОРД */\n.leaderboard-section {\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.leaderboard-title {\n  font-size: 14px;\n  font-weight: 900;\n  text-align: center;\n  color: #d4af37;\n  margin-bottom: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.leaderboard-list {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.leaderboard-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  background: rgba(0,0,0,0.3);\n  border-radius: 6px;\n  border-left: 3px solid #666;\n}\n\n.leaderboard-item.gold {\n  border-left-color: #d4af37;\n  background: rgba(212, 175, 55, 0.1);\n}\n\n.leaderboard-item.silver {\n  border-left-color: #c0c0c0;\n  background: rgba(192, 192, 192, 0.1);\n}\n\n.leaderboard-item.bronze {\n  border-left-color: #cd7f32;\n  background: rgba(205, 127, 50, 0.1);\n}\n\n.rank-number {\n  font-size: 14px;\n  font-weight: bold;\n  color: #aaa;\n  min-width: 30px;\n}\n\n.player-name {\n  flex: 1;\n  text-align: center;\n  font-size: 14px;\n  color: #e0c097;\n}\n\n.player-score {\n  font-size: 16px;\n  font-weight: bold;\n  color: #4cd137;\n  min-width: 40px;\n  text-align: right;\n}\n\n/* КНОПКА ЗАКРЫТИЯ */\n.safecracker-close-btn {\n  background: linear-gradient(to bottom, #d4af37, #aa8c2c);\n  color: #3e2723;\n  border: 2px solid #7c641d;\n  border-radius: 8px;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: 900;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  font-family: 'Courier New', monospace;\n  cursor: pointer;\n  box-shadow: 0 4px 0 #7c641d;\n  transition: all 0.1s;\n  margin-top: auto;\n}\n\n.safecracker-close-btn:active {\n  transform: translateY(4px);\n  box-shadow: 0 0 0 #7c641d;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
